<template>
    <bar-metrics class="rating-metrics my-1" :data="entries" :show-percentages="false"></bar-metrics>
</template>
<style lang="sass" scoped>
    .panel-body
        .star
            margin-bottom: 18px

            &:last-child
                margin-bottom: 0

        .rating-metrics
            ::v-deep
            .label
                min-width: 35px

                .bar-item
                    &:first-child
                        margin-top: 0

                    &:last-child
                        margin-bottom: 0
</style>
<script>
    export default {
        props: {
            data: {
                required: true,
                type: Array
            },
        },

        computed: {
            entries() {
                const total = _.max(this.data);
                const entries = _.times(this.data.length, (number) => {
                    const starNumber = number + 1;
                    const data = this.data[number];
                    return {
                        label: `<span>${starNumber}<i class="fa fa-star ml-2" style="color: silver"></i></span>`,
                        data
                    };
                });

                return entries.reverse();
            }
        },
    };
</script>
